export type SellerSupportMessageSender = 'SELLER' | 'SUPER_ADMIN';

export interface SellerSupportMessage {
  id: number;
  threadId: number;
  senderKind: SellerSupportMessageSender;
  body: string;
  imageUrls: string[];
  senderName: string | null;
  createdAt: string;
}

export interface SellerSupportMessagesResponse {
  items: SellerSupportMessage[];
  total: number;
  threadId: number;
}

export interface SellerSupportThreadSummary {
  threadId: number;
  sellerId: number;
  shopName: string;
  shopLogoUrl: string | null;
  lastMessage: SellerSupportMessage | null;
  unreadCount: number;
  updatedAt: string;
}

export interface SellerSupportThreadsResponse {
  items: SellerSupportThreadSummary[];
  total: number;
}

export interface SellerSupportChatMessageEvent {
  sellerId: number;
  shopName: string | null;
  message: SellerSupportMessage;
}

export const SELLER_SUPPORT_CHAT_WS_NAMESPACE = '/seller-support-chat';
export const SELLER_SUPPORT_CHAT_WS_PATH = '/api/ws';

export const SELLER_SUPPORT_CHAT_EVENTS = {
  messageNew: 'chat:message',
  unread: 'chat:unread',
} as const;
